var map = {
	"./btn-start.png": 465,
	"./checkbox-checked.svg": 5957,
	"./checkbox.svg": 1453,
	"./common/checkbox-checked.svg": 9235,
	"./common/checkbox.svg": 9735,
	"./common/contact-klc.svg": 3739,
	"./common/down-white.svg": 3448,
	"./common/down.svg": 7464,
	"./common/estimate-btn-sp.png": 9181,
	"./common/estimate-btn.png": 337,
	"./common/estimate-fixed.png": 6279,
	"./common/fixed-klc-sp.svg": 4919,
	"./common/left-arrow--white.svg": 8348,
	"./common/logo.svg": 7761,
	"./common/page-top.svg": 4531,
	"./common/pict-couple-senior.svg": 5630,
	"./common/pict-couple.svg": 1845,
	"./common/pict-family.svg": 8597,
	"./common/pict-flowchart.svg": 191,
	"./common/pict-lifestage.svg": 8039,
	"./common/pict-operator.svg": 4189,
	"./common/pict-risk.svg": 6320,
	"./common/pict-simulator.svg": 5117,
	"./common/pict-single.svg": 6245,
	"./common/qa-a.svg": 2788,
	"./common/qa-q.svg": 2372,
	"./common/radio-checked.svg": 3389,
	"./common/radio.svg": 2373,
	"./common/right-arrow--white.svg": 287,
	"./common/right-circle.svg": 6092,
	"./common/slick-left.svg": 4830,
	"./common/slick-right.svg": 205,
	"./common/tip.svg": 9075,
	"./pict-couple-senior.svg": 2500,
	"./pict-couple.svg": 1991,
	"./pict-family.svg": 339,
	"./pict-single.svg": 1699,
	"./radio-checked.svg": 1479,
	"./radio.svg": 651,
	"./risk/reason-person.png": 1566,
	"./risk/risk-car.svg": 7326,
	"./risk/risk-estate.svg": 28,
	"./risk/risk-health.svg": 8886,
	"./risk/risk-life.svg": 9410
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;